import React from 'react'
import PropTypes from 'prop-types'
import { Button, Container, Divider, Form, Icon } from 'semantic-ui-react'
import AuthenticationShell from 'shared/components/AuthenticationShell'
import { EmailInput } from 'components/EmailInput'
import { Link } from 'react-router-dom'

export default ResetPassword
function ResetPassword({ onChange, onSubmit, value }) {
  return (
    <AuthenticationShell
      headerText={
        <>
          <i className="far fa-lock icon" /> Reset your password
        </>
      }
    >
      <Form onSubmit={onSubmit}>
        <Form.Field>
          <label>Email</label>
          <EmailInput onChange={onChange} value={value} />
        </Form.Field>
        <Button primary fluid type="submit">
          Reset password
        </Button>
      </Form>

      <Container textAlign="center">
        <Divider hidden />
        <Link to={{ pathname: '/login/', search: location.search }}>
          <Icon className="fas fa-arrow-left" />
          Back to login
        </Link>
      </Container>
    </AuthenticationShell>
  )
}

ResetPassword.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/ResetPassword/index.js